import { SnackBarService } from './snackBar.service';
import { Usuario } from './../../models/general/usuario.model';
import { Injectable, AfterViewInit, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { Idle } from 'idlejs/dist';
import { ResponseHelper } from 'src/app/models/sistema/responseHelper';
import { ParamEntity } from 'src/app/models/general/param.model';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class UserValuesService {
  private loggedInBehavior = new BehaviorSubject<boolean>(false);
  usuarioLogueado: Usuario;
  private loggedInStatus = false;
  private status = false;
  tiempoInactividad = 15;
  private paramLogoutDb: ParamEntity<any>;

  /* Objeto para observar la inactividad del usuario.
  si no presiona nada por 15 minutos, lo deslogueamos */
  idle = new Idle()
    .whenNotInteractive()
    .within(this.tiempoInactividad)
    .do(() => {
      if (this.checkCookieExists) {
        this.setLogout(true);
      }
    }).start();

  constructor(
    private loginService: LoginService,
    // private storage: StorageMap,
    private cookieService: CookieService,
    private route: Router,
    private _snackBar: SnackBarService,
    private dialogRef: MatDialog) {
    this.usuarioLogueado = new Usuario();
    this.usuarioLogueado.IdEmpresa = 1; // BORRAR UNA VEZ QUE ESTE LISTO EL MULTIEMPRESA
    this.setLoggedIn(this.cookieService.check('logueado-admin'));
    if (this.isLogueado) {
      this.getUsuarioSuccess(false);
    }
  }

  /* Devolvemos una promesa para asi hacer logica en
    el componente.
  */
  setLogin(userName: string, pass: string): Promise<boolean> {
    return this.loadLoginUser(userName, pass).then(() => this.usuarioLogueado.Ok);
  }

  setUserHubId(id: string) {
    this.usuarioLogueado.userHubId = id;
  }

  /* Valida contra la BD con usr y pass. Si obtenemos un TRUE como respuesta
    guardamos todos los valores necesarios del usuario en las cookies del browser
  */
  loadLoginUser(userName: string, pass: string) {
    return this.loginService.ValidarUsuario(userName, pass).toPromise().then((result: Usuario) => {
      this.usuarioLogueado = result;
      this.usuarioLogueado.IdEmpresa = 1; // BORRAR UNA VEZ QUE ESTE LISTO EL MULTIEMPRESA
      if (this.usuarioLogueado.Ok) {
        this.cookieService.set('tipoLogin', 'admin');
        this.paramLogoutDb = new ParamEntity<any>();
        this.paramLogoutDb.GenericData = result.IdUserLog;
        this.loggedInBehavior.next(true); // Seteo la variable en TRUE para el navbar (logueado)
        this.cookieService.set('logueado-admin', JSON.stringify(true));
        localStorage.setItem('user', JSON.stringify(this.getUsuarioSuccess(true)));
        this.setLoggedIn(true);
        this.checkLocalStorageLogout();
        this.setIntervalSaveLocalStorageData();
        this.route.navigate(['home']);
      }
    }).catch((error) => { this.getUsuarioValues.Mensaje = error.error; this.getUsuarioValues.Ok = false; });
  }

  /* Si estamos en la pantalla de LOGIN, envia un TRUE para
   crear un nuevo usuario logueado.
   Si se refresca la pagina, busca los datos que esten
   en las cookies y los obtenemos. */
  getUsuarioSuccess(nuevoLogin) {
    let usuarioCookie = new Usuario();

    if (nuevoLogin) {
      usuarioCookie.IdUserLog = this.usuarioLogueado.IdUserLog;
      usuarioCookie.IdEmpresa = this.usuarioLogueado.IdEmpresa;
      usuarioCookie.IdRol = this.usuarioLogueado.IdRol;
      usuarioCookie.IdUsuario = this.usuarioLogueado.IdUsuario;
      usuarioCookie.Ok = this.usuarioLogueado.Ok;
      usuarioCookie.NomUsuario = this.usuarioLogueado.NomUsuario;
      usuarioCookie.FechaLogin = this.usuarioLogueado.FechaLogin || new Date();
      this.usuarioLogueado.FechaLogin = usuarioCookie.FechaLogin;
      usuarioCookie.SistMenu = this.usuarioLogueado.SistMenu;
    } else {
      usuarioCookie = JSON.parse(localStorage.getItem('user'));
      this.loggedInBehavior.next(true); // Seteo la variable en TRUE para el navbar (logueado)
      Object.assign(this.usuarioLogueado, usuarioCookie);
    }
    return usuarioCookie;
  }

  // Setea el login en TRUE cuando inicia sesion
  setLoggedIn(value: boolean) {
    this.loggedInStatus = value;
  }

  // Nos devuelve el estado del logueo (si esta logueado o no)
  get isLogueado() {
    return this.loggedInStatus;
  }

  // Para desloguearnos. Cierra todos los modals que esten
  // abiertos en la app. Luego llama a funcion para
  // que esten almacenados en la web
  setLogout(inactividad = false) {
    this.dialogRef.closeAll();
    this._snackBar.openSnackBar('snack-warning', 'Redirigiendo al login', 3000);
    this.removeLogoutData().subscribe((result) => {
      if (result) {
        this.cookieService.delete('tipoLogin');
        this.logoutDatabase(inactividad);
      } else {
        this._snackBar.openSnackBar('snack-danger', 'Hubo un problema al cerrar la sesión', 3000);
      }
    });
  }

  private logoutDatabase(inactividad) {
    const paramEntity = new ParamEntity();
    paramEntity.GenericData = this.getUsuarioValues.IdUserLog;
    paramEntity.Inactividad = inactividad;
    paramEntity.TiempoInactividad = this.tiempoInactividad;

    this.loginService.setLogOutService(paramEntity).subscribe((result: ResponseHelper) => {
      if (result.Ok) {
        this.route.navigate(['login']);
      } else {
        this._snackBar.openSnackBar('snack-danger', 'Hubo un problema al cerrar la sesión', 3000);
      }
    }, (error) => { this._snackBar.openSnackBar('snack-danger', 'Hubo un problema al cerrar la sesión', 3000); })
  }

  // Primero verifica que haya una cookie
  // si existe, elimina todo dato almacenado en el navegador
  // y devuelve un TRUE
  removeLogoutData(): Observable<boolean> {
    if (!this.checkCookieExists) {
      return of(false);
    }
    this.loggedInBehavior.next(false); // Seteo la variable en FALSE para el navbar (no logueado)
    this.cookieService.delete('logueado-admin');
    this.setLoggedIn(false);
    localStorage.removeItem('user');
    return of(true);
  }

  // Nos devuelve el estado de la cookie
  // si existe o no
  get checkCookieExists() {
    return this.cookieService.check('logueado-admin');
  }

  // Nos devuelve el objeto del usuario logueado
  get getUsuarioValues() {
    return this.usuarioLogueado;
  }

  get isLoggedInBehavior() {
    return this.loggedInBehavior.asObservable(); // {2}
  }

  setLoggedInBehavior(value) {
    this.loggedInBehavior.next(value);
  }

  private setIntervalSaveLocalStorageData() {
    setTimeout(() => {
      setInterval(() => {
        const paramEntity = new ParamEntity();
        paramEntity.GenericData = this.getUsuarioValues.IdUserLog;
        this.loginService.getServerDateService().subscribe((date: any) => {
          if (date) {
            paramEntity.FechaDate = date;
          }
          localStorage.setItem('logoutData', JSON.stringify(paramEntity));
        });

      }, 5000)
    }, 8000);
  }

  private checkLocalStorageLogout() {
    const localData: ParamEntity<any> = JSON.parse(localStorage.getItem('logoutData'));
    if (localData) {
      if (localData.GenericData !== this.paramLogoutDb.GenericData) {
        this.loginService.getServerDateService().subscribe((date: any) => {
          const paramEntity = new ParamEntity();
          paramEntity.GenericData = localData.GenericData;
          paramEntity.FechaDate = date;
          this.saveLocalStorageDataDb(paramEntity);
        })
      }
    }
  }

  private saveLocalStorageDataDb(paramEntity) {
    this.loginService.setLogOutLocalStorageService(paramEntity).subscribe((result: ResponseHelper) => {
      // POR EL MOMENTO NO ES NECESARIO HACER NADA CON UNA RESPUESTA DEL SERVICIO
      if (result.Ok) {
        // this.route.navigate(['login']);
      } else {
        // this._snackBar.openSnackBar('snack-danger', 'Hubo un problema al cerrar la sesión', 3000);
      }
    }, (error) => { })
  }
}
